import * as React from 'react';
import { createComponent } from '@lit/react';
import { UniversalNavHelpWC } from './universal-nav-help.wc';

export const UniversalNavHelp = createComponent({
  tagName: UniversalNavHelpWC.tagname,
  elementClass: UniversalNavHelpWC,
  react: React,
});
